import { CurrencyTextField } from '@/common/components/CurrencyTextField'
import MaskedTextField from '@/common/components/MaskedTextField'
import { percentageMask } from '@/common/constants/masks.constant'
import { CreateSpecialEntryValidationSchema } from '@/features/privateCompanies/schemas/createSpecialEntry.schema'
import { useFormContext } from 'react-hook-form'

interface FormEntryTextFieldProps {
  disabled?: boolean
  className?: string
}

export const FormEntryTextField = ({ disabled, className }: FormEntryTextFieldProps) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<CreateSpecialEntryValidationSchema>()

  const calculateAs = watch('calculate_as')

  return (
    <>
      {calculateAs === 'percentage' ? (
        <MaskedTextField
          mask={percentageMask}
          label="Valor"
          className={className}
          {...register('value')}
          errorMessage={errors?.value?.message}
          disabled={disabled}
          markAsRequired
        />
      ) : (
        <CurrencyTextField
          label="Valor"
          className={className}
          allowZero
          {...register('value')}
          errorMessage={errors?.value?.message}
          disabled={disabled}
          markAsRequired
        />
      )}
    </>
  )
}
